import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import {Grid, Icon} from '@mui/material';
import type * as React from 'react';
import {useMemo} from 'react';
import type {EmployeeActuals} from '@/types/Actuals';

type ActualProps = {
    scheduled : number | React.ReactElement;
    actual ?: EmployeeActuals;
    capacityYearMonth : string;
    client ?: boolean;
    timeOff ?: boolean;
    capacityDefault ?: number;
    changedFromDefaults ?: boolean;
};

export const ActualVsScheduled = ({
    scheduled, actual, capacityYearMonth, client, timeOff, changedFromDefaults, capacityDefault,
} : ActualProps) : React.ReactElement => {
    const month = useMemo(() => {
        return actual?.months.find(m => m.id === capacityYearMonth);
    }, [actual, capacityYearMonth]);

    let actuals = '';

    if (month) {
        if (client) {
            actuals = month.clientHours.toFixed(1);
        } else if (timeOff) {
            actuals = month.timeOffHours.toFixed(1);
        }
    }

    return (<Grid container spacing={0} alignItems="center">
        <Grid
            item
            xs={6}
            sx={{
                textAlign: 'right',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
            }}
        >
            {changedFromDefaults
                ? <Icon fontSize="small" sx={{pr: {lg: 1}}} title={`Default is ${capacityDefault ?? ''}`}>
                    <ChangeHistoryIcon/>
                </Icon>
                : ''
            }
            {scheduled}
        </Grid>
        <Grid
            item
            xs={6}
            sx={{
                color: '#a98a00',
                textAlign: 'right',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                pl: 1,
            }}
        >
            {actuals}
        </Grid>
    </Grid>);
};
